<template>
  <v-layout row justify-center>
    <v-dialog 
      transition="slide-y-transition"
      v-model='confirmDialog' 
      @keydown.esc='close' 
      persistent 
      max-width="290">
      <v-card class="confirm-dialog">
        <v-card-title class="headline">{{ $t('request.confirm.text') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="close">{{ $t('request.confirm.cancelBtn') }}</v-btn>
          <v-btn color="green darken-1" flat @click="cancelRequest">{{ $t('request.confirm.confirmBtn') }}</v-btn>
        </v-card-actions>
        <!-- Alert -->
        <v-layout row v-if='errorAlert.state'>
            <v-flex sm12 >
              <v-alert :value="errorAlert.state" type="error">
                {{ errorAlert.msg }}
            </v-alert>
            </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'ConfirmDialog',
    data() {
      return {
        id: '',
        errorAlert: {
          state: false,
          msg: '',
        },
      };
    },
    computed: {
      confirmDialog: {
        get() {
          return this.$store.getters['dashboard/requests/confirmDialogState'];
        },
        set(value) {
          if (!value) {
            this.close();
          }
        },
      },
      cancelItemId() {
        return this.$store.getters['dashboard/requests/getCancelItemId'];
      },
    },
    methods: {
      async cancelRequest() {
        const data = await this.$store.dispatch('dashboard/requests/cancelRequest', { order_id: this.cancelItemId });

        if (data.data.success) {
          this.$store.commit('dashboard/requests/toggleConfirmDialog', false);
        } else {
          this.errorAlert.state = true;
          this.errorAlert.msg = data.data.err;
        }
      },
      close() {
        this.$store.commit('dashboard/requests/toggleConfirmDialog', false);
        this.errorAlert.state = false;
        this.errorAlert.msg = '';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .confirm-dialog {
    .v-btn {
      text-transform: initial;
    }
  }
</style>


// WEBPACK FOOTER //
// src/shared/components/ConfirmCancelOrderDialog.vue